import React, { useState, useEffect, useRef } from 'react';
import {Query} from 'react-apollo';
import {Table, Row, Cell} from './tableUtils';
import UpdateUser from './updateUser';
// import AddBtn from '../addBtn/addBtn';
import CreateUser from './createUser';
import css from './usersTable.scss';
import {GET_USERS} from './queries';
import {Redirect} from 'react-router';
import axios from 'axios';

function UsersTable(props){
		const authToken = localStorage.getItem('token');
		const effectCount = useRef(0);
		const [originalData, setOriginalData] = useState([]);
		const [downloadable, setDownloadable] = useState(['ici c\'est paris']);
		const [users, setUsers] = useState(null);
		const [getParams, setGetParams] = useState([]);
		const [links, setLinks] = useState([1]);
		const [srchByNom, setSrchByNom] = useState('');
		const [srchByGroupe, setSrchByGroupe] = useState('');
		const [sort, setSort] = useState(null);
		const [nb, setNb] = useState(25);
		const [page, setPage] = useState(1);
		const hostname = window.location.hostname;
		const backendDev = 'http://localhost:4500/';
		const backendPreprod = 'http://backend.solar-management.web.adelios.fr/';
		const backendProd = 'https://backend.solar-management.adelios.fr/';
		let backendURI;

		switch (hostname) {
			case 'admin.solar-management.web.adelios.fr':
				backendURI = backendPreprod;
				break;
			case 'admin.solar-management.adelios.fr':
				backendURI = backendProd;
				break;
			default:
				backendURI = backendDev;
		}

		const showSearchBar = target => {
			target.style.display = "none";
			target.previousSibling.style.display = "none";
			target.nextSibling.style.display = "grid";
		}
		const search = () => {
			let params = ['nb='+nb, 'page='+page];

			if (sort) params.push('ods='+sort[0], 'sob='+sort[1])

			if (srchByNom !== '' && srchByNom !== 'BlAdij^76x.e') {
				params.push('sbn='+encodeURIComponent(srchByNom))
			} else if (srchByGroupe !== '' && srchByGroupe !== 'BlAdij^76x.e') {
				params.push('sbg='+encodeURIComponent(srchByGroupe))
			}

			console.log("/utilisateurs?" + params.join('&'));
			window.location.href = "/utilisateurs?" + params.join('&');
		}
		const download = async e => {
			let format = document.querySelector('input[name="format"]:checked');
			if (format === null) {
				alert("Choisissez le type de document que vous voulez");
			} else {
				let edited = downloadable.map(v => {
					let c = {...v};
					c['nom'] = c.lastname;
					delete c.lastname;
					c['prenom'] = c.firstname;
					delete c.firstname;
					c['groupe'] = c.group === null ? 'pas de groupe' : v.group.name;
					delete c.group;
					c['activite'] = c.enabled === true ? 'oui' : 'non';
					delete c.enabled;
					delete c.id;
					delete c.__typename;
					return c;
				});
				format = format.value;
				const res = await axios.post(backendURI+'csvxls', {users: edited, format});
				window.location = backendURI + res.data.path;
				console.log(edited);
				console.log(format);
				console.log(res);
			}
		}

		useEffect(() => {
			let params = {};

			window.location.search.substr(1).split("&").forEach(item => {
				item = item.split("=").map(v => decodeURIComponent(v));
				params[item[0]] = item[1]
			});

			for (let i in params) {
				if (params[i] == undefined || params[i] == null || params[i].trim() == '') {
					delete params[i];
				}
			}

			setGetParams(params);
		}, []);

		useEffect(() => {
			let copy = [...originalData];
			if (copy.length === 0) return;
			let nB = [5, 10, 25, 50, 100, 200].includes(parseInt(getParams['nb'])) ? getParams['nb'] : 25;
			let searchByNom = getParams['sbn'] !== undefined ? getParams['sbn'] : null;
			let searchByGroupe = getParams['sbg'] !== undefined ? getParams['sbg'] : null;
			let sortBy = getParams['sob'] !== undefined ? getParams['sob'] : null;
			let sortOrder = getParams['ods'] !== undefined ? getParams['ods'] : null;
			let newLinks = [];

			if (['nom', 'groupe'].includes(sortBy) && ['asc', 'desc'].includes(sortOrder)) {
				if (sortBy === 'nom') {
					if (sortOrder === 'asc') {
						copy.sort((a, b) => a.lastname.toLowerCase().localeCompare(b.lastname.toLowerCase()));
					} else {
						copy.sort((a, b) => b.lastname.toLowerCase().localeCompare(a.lastname.toLowerCase()));
					}
				} else {
					if (sortOrder === 'asc') {
						copy.sort((a, b) => a.group == null || b.group == null ? true : a.group.name.toLowerCase().localeCompare(b.group.name.toLowerCase()))
					} else {
						copy.sort((a, b) => a.group == null || b.group == null ? true : b.group.name.toLowerCase().localeCompare(a.group.name.toLowerCase()))
					}
				}
			}

			if (searchByNom !== null) {
				document.querySelector('#nomSpan').style.display = 'none';
				document.querySelector('#nomSpan').nextSibling.style.display = 'none';
				document.querySelector('#nomInput').style.display = 'grid';
				document.querySelector('#nomInput input').value = searchByNom;
				setSrchByNom(searchByNom);
				copy = copy.filter(v => {
					if (v.lastname.toLowerCase().match(new RegExp(searchByNom, 'g'))) {
						return true;
					} else {
						return false;
					}
				});
			} else if (searchByGroupe !== null) {
				document.querySelector('#groupeSpan').style.display = 'none';
				document.querySelector('#groupeSpan').nextSibling.style.display = 'none';
				document.querySelector('#groupeInput').style.display = 'grid';
				document.querySelector('#groupeInput input').value = searchByGroupe;
				setSrchByGroupe(searchByGroupe);
				copy = copy.filter(v => {
					if (v.group !== null) {
						if (v.group.name.toLowerCase().match(new RegExp(searchByGroupe, 'g'))) {
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				})
			}

			document.querySelector("."+css.nbResults+"[value='"+nB+"']").selected = true;

			let pages = Math.ceil(copy.length/nB);

			for (let i = 1; i <= pages; i++) {
				newLinks.push(i);
			}

			let pagE = newLinks.includes(parseInt(getParams['page'])) ? getParams['page'] : 1;

			setPage(pagE);
			setSort(sortBy === null ? null : [sortOrder, sortBy]);
			setNb(nB);
			setLinks(newLinks);
			setDownloadable([...copy]);
			copy = copy.splice((pagE-1)*nB, nB);
			setUsers(copy);
		}, [originalData]);

		useEffect(() => {
			if (effectCount.current >= 2) {
				search();
			}
			effectCount.current++;
		}, [page, nb, sort]);

		useEffect(() => {
			if (srchByGroupe === 'BlAdij^76x.e' || srchByNom === 'BlAdij^76x.e') {
				search();
			}
		}, [srchByNom, srchByGroupe]);

		if (!authToken) {
			return <Redirect to="/" />;
		}
		return (
			<div>
				<div className={css.downloadVue}>
					<div className={css.vue}>
						<span>Vue</span>
						<select onChange={e => setNb(e.target.value)}>
							<option className={css.nbResults} value="5">5</option>
							<option className={css.nbResults} value="10">10</option>
							<option className={css.nbResults} value="25">25</option>
							<option className={css.nbResults} value="50">50</option>
							<option className={css.nbResults} value="100">100</option>
							<option className={css.nbResults} value="200">200</option>
						</select>
					</div>
					<div className={css.download}>
						<span>Télécharger</span>
						<input type="radio" id="csv" name="format" value="csv" />
						<label for="csv">.csv</label>
						<input type="radio" id="xlsx" name="format" value="xlsx" />
						<label for="xlsx">.xlsx</label>
						<img onClick={e => download(e)} alt="" src="/triangle-teal-big.png" className={css.triangleBig}/>
					</div>
				</div>
				<Table key="usersTable">
					<Row head>
						<Cell head type="deleteCol" />

						<Cell head>
							<img alt="" onClick={() => setSort(['asc', 'nom'])} style={{position: "absolute", left: "-50px"}} title={'Trier par ordre croissant (de A à Z)'} src="/triangle.png" className={css.triangle}/>
							<img alt="" onClick={() => setSort(['desc', 'nom'])} style={{position: "absolute", left: "-30px"}} title={'Trier par ordre décroissant (de Z à A)'} src="/triangle.png" className={css.triangle + ' ' + css.reversedTriangle}/>
							<span id="nomSpan" >Nom</span>
							<img alt="" style={{}} onClick={e => showSearchBar(e.target)} className={css.searchIcon} src="/search-icon.png" />
							<div id="nomInput" className={css.searchBar}>
								<input type="text" placeholder="Nom..." onChange={e => setSrchByNom(e.target.value.trim().replace(/\s+/g, ' ').toLowerCase())}/>
								<div>
									<img onClick={() => setSrchByGroupe('BlAdij^76x.e')} alt="" src="/triangle-teal-big.png" className={css.triangleBig}/>
								</div>
							</div>
						</Cell>

						<Cell head>
							<span>Prénom</span>
						</Cell>

						<Cell head type="email">
							<span>Email</span>
						</Cell>

						<Cell head type="group" center>
							<img alt="" onClick={() => setSort(['asc', 'groupe'])} style={{}} title={'Trier par ordre croissant (de A à Z)'} src="/triangle.png" className={css.triangle}/>
							<img alt="" onClick={() => setSort(['desc', 'groupe'])} style={{marginRight: "5px"}} title={'Trier par ordre décroissant (de Z à A)'} src="/triangle.png" className={css.triangle + ' ' + css.reversedTriangle}/>
							<span id="groupeSpan">Groupe</span>
							<img alt="" style={{}} onClick={e => showSearchBar(e.target)} className={css.searchIcon} src="/search-icon.png" />
							<div  id="groupeInput" className={css.searchBar}>
								<input type="text" placeholder="Groupe..." onChange={e => setSrchByGroupe(e.target.value.trim().replace(/\s+/g, ' ').toLowerCase())}/>
								<div>
									<img onClick={() => setSrchByNom('BlAdij^76x.e')} alt="" src="/triangle-teal-big.png" className={css.triangleBig}/>
								</div>
							</div>
						</Cell>

						<Cell head type="enable" center>
							Activé
						</Cell>
					</Row>
					<Query query={GET_USERS}>
						{({loading, error, data}) => {
							if (loading) {
								return <div className={css.error}>Loading</div>;
							}
							if (error) {
								return (
									<div className={css.error}>
										Une erreur est survenue :{' '}
										<strong>
											{error.graphQLErrors[0]}
										</strong>
									</div>
								);
							}
							if (data.users.length !== 0) {
								setOriginalData(data.users);
							}
							return null;
						}}
					</Query>
					<CreateUser key="create" />
					{users === null ?
						null
					: users.length === 0 ?
						<div className={css.error}>Pas de résultats...</div>
					:
						users.map((data, i) => (
							<UpdateUser key={data.id} {...data} />
						))
					}
				</Table>
				{users === null || users.length === 0 ?
					null
				:
					<div className={css.prevNext}>
						{links.includes((page - 1))?
							<a onClick={() => setPage(page - 1)}>Précédent</a>
						:
							null
						}
						<select onChange={e => setPage(e.target.value)}>
							{links.map(v => (
								<option selected={v == page ? true : false} className={css.page} value={v}>{v}</option>
							))}
						</select>
						{links.includes(parseInt(page) + 1) == true ?
							<a  onClick={() => setPage(parseInt(page) + 1)}>Suivant</a>
						:
							null
						}
						</div>
				}
			</div>
			// <AddBtn key="btn">Ajouter un utilisateur</AddBtn>,
		);
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/usersTable/usersTable.js